import React from 'react'
import { Box } from '@maui/elements'

export const CampaignSearchPreview = ({ data }) => {
  const {
    name
  } = data
  return (
    <Box>
      {name}
    </Box>
  )
}
